<!-- #region Footer -->
<footer [ngClass]="lang" class="footer-copyright text-center py-3">
  <div *ngIf="lang=='en'" class="wow fadeInUp">
    © 2019 Copyright:
    <a>Company Information Technology</a>
  </div>
  <div *ngIf="lang=='ar'" class="wow fadeInUp">
    © 2019 حقوق النشر:
    <a>Company Information Technology</a>
  </div>
</footer>
<!-- #endregion -->
